import { isBefore, isSameDay, startOfDay } from "date-fns";
import { TICKET_STATUS } from "pages/AccountSettlementHistoryOrderId/constants/TicketStatus";

import type { TimeStamp } from "pages/AccountSettlementHistoryOrderId/types/TimeStamp";

type TicketStatus = (typeof TICKET_STATUS)[keyof typeof TICKET_STATUS];

type EventPart = {
  name: string;
  openTime: TimeStamp;
};

const getStatus = (sortedParts: EventPart[], today: Date): TicketStatus => {
  if (sortedParts.length === 0) return TICKET_STATUS.ENDED;

  const hasOnGoingPart = sortedParts.some((part) => {
    const eventDate = startOfDay(new Date(part.openTime.seconds * 1000));
    return isSameDay(today, eventDate);
  });
  if (hasOnGoingPart) return TICKET_STATUS.ON_GOING;

  const hasFuturePart = sortedParts.some((part) => {
    const eventDate = startOfDay(new Date(part.openTime.seconds * 1000));
    return isBefore(today, eventDate);
  });
  if (hasFuturePart) return TICKET_STATUS.BEFORE_OPENING;

  return TICKET_STATUS.ENDED;
};

export const getTicketStatus = (
  eventParts: EventPart[]
): {
  status: TicketStatus;
  firstPartTime: TimeStamp | null;
  lastPartTime: TimeStamp | null;
} => {
  const sortedParts = [...eventParts].sort(
    (a, b) => a.openTime.seconds - b.openTime.seconds
  );

  const [firstPart] = sortedParts;
  const lastPart = sortedParts[sortedParts.length - 1];
  const today = startOfDay(new Date());

  return {
    status: getStatus(eventParts, today),
    firstPartTime: firstPart?.openTime ?? null,
    lastPartTime: lastPart?.openTime ?? null,
  };
};
